export function StatusLabel({ children, tone = "neutral" }) {
  return <span className={`status-label status-label--${tone}`}>{children}</span>;
}
